export default __webpack_public_path__ + "static/media/end.6a641fb1.svg";